<template>
  <div v-if="user.id">
    <NewClient />
  </div>
</template>

<script>
import NewClient from '@/components/hr/new-client.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    NewClient
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>
